import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_ENDPOINT, USER_API_ENDPOINT } from '../config';
import { UpdateUserBasicInfoModel, UpdateUserPasswordModel, UpgradeUserModel, User } from './../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getUsers(): Observable<any> {
    return this.httpClient.get(USER_API_ENDPOINT + '/user/all').pipe(
      map(res => res)
    )
  }

  getUserSelectList(): Observable<any> {
    return this.httpClient.get(USER_API_ENDPOINT + '/user/select-list').pipe(
      map(res => res)
    )
  }

  getById(id: string): Observable<any> {
    return this.httpClient.get(USER_API_ENDPOINT + '/user/' + id).pipe(
      map(res => res)
    );
  }

  getUserBasicInfo(): Observable<any> {
    return this.httpClient.get(USER_API_ENDPOINT + '/user/my-basic-info').pipe(
      map(res => res)
    );
  }

  deleteUser(id: string): Observable<any> {
    return this.httpClient.delete(USER_API_ENDPOINT + '/user/' + id).pipe(
      map(res => res)
    );
  }

  deleteMyUser(): Observable<any> {
    return this.httpClient.delete(USER_API_ENDPOINT + '/user/my-user').pipe(
      map(res => res)
    );
  }

  createUser(user: User): Observable<any> {
    return this.httpClient.post(USER_API_ENDPOINT + '/user/', user).pipe(
      map(res => res)
    )
  }

  updateUser(user: User): Observable<any> {
    return this.httpClient.put(USER_API_ENDPOINT + '/user/' + user.id, user).pipe(
      map(res => res)
    )
  }

  upgradeUser(user: UpgradeUserModel): Observable<any> {
    return this.httpClient.put(USER_API_ENDPOINT + '/user/' + user.id + '/upgrade', user).pipe(
      map(res => res)
    )
  }

  activateUser(id: string): Observable<any> {
    return this.httpClient.put(USER_API_ENDPOINT + '/user/' + id + '/activate', null).pipe(
      map(res => res)
    )
  }

  updateMyProfile(user: UpdateUserBasicInfoModel): Observable<any> {
    return this.httpClient.put(USER_API_ENDPOINT + '/user/update-my-profile', user).pipe(
      map(res => res)
    )
  }
  
  changePassword(model: UpdateUserPasswordModel): Observable<any> {
    return this.httpClient.put(USER_API_ENDPOINT + '/user/change-my-password', model).pipe(
      map(res => res)
    );
  }

  getUserEducationInfo(): Observable<any> {
    return this.httpClient.get(USER_API_ENDPOINT + '/user/my-education').pipe(
      map(res => res)
    );
  }

  getUserProfessionInfo(): Observable<any> {
    return this.httpClient.get(USER_API_ENDPOINT + '/user/my-profession').pipe(
      map(res => res)
    );
  }

  sendActivation(): Observable<any> {
    return this.httpClient.put(USER_API_ENDPOINT + '/user/send-activation-code', null).pipe(
      map(res => res)
    );
  }
}
